import Vue from 'vue'
import Vuex from 'vuex'

import ui from './ui'
import products from './products.js'
import product from './product.js'
import providers from './providers.js'
import provider from './provider.js'
import version from './version.js'
import user from './user.js'
import log from './log.js'
import me from './me.js'
import users from './users'
import categories from './categories'
import apiKeys from './api-keys'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    ui,
    products,
    product,
    providers,
    provider,
    version,
    user,
    log,
    me,
    users,
    categories,
    apiKeys,
  },
})
